module.exports = fox._r("images/cf-placeholder.gif", __webpack_public_path__ + "_/_/_/root/images/cf-placeholder.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/cf-placeholder.gif
// module id = 727
// module chunks = 4